const BackImageModel = require("@/appModel/BackImage/BackImageModel");
const TreeModel = require("@/appModel/Tree/TreeModel");
const TreeItemModel = require("@/appModel/Tree/TreeItemModel")
const InspectMasterModel = require("@/appModel/InspectMaster/InspectMasterModel")
const TenantStorage = require("@/appUtils/TenantStorage")
const mime = require('mime-types');

class FileUploadViewModel {
  constructor(tenantId, projectId, parentNode) {
    this.tenantId = tenantId
    this.projectId = projectId
    this.parentNode = parentNode
    this.nodeId = null
    
  }
  /**
   * 初期処理
   */
  async init(fileBody, fileName, fileSize) {
    this.fileSize = fileSize
    this.fileBody = fileBody
    this.fileName = fileName
    this.treeItem = await TreeItemModel.getNewData(this.projectId)
    this.treeItem.lsiStr1 = this.parentNode.sk
    this.treeItem.lsiInt1 = this.parentNode.lsiInt1 + 1
  
    this.treeItem.treeItem.type = "file"
    console.log(`JSON ${JSON.stringify(this.treeItem)}`)
    this.nodeId = this.treeItem.treeItem.id
    this.tenantStorage = new TenantStorage(this.tenantId)
    // }
  }

  /**
   * ファイルをアップロード
   */
  async uploadFile() {

    try {
      
      if (!this.tenantId || !this.projectId || !this.nodeId) {
        throw `パラメータ不足 tenantId:${this.tenantId} projectId:${this.projectId} nodeId:${this.nodeId}`
      }

      // S3キー名
      const s3Key = this.tenantStorage.createNodeFileKey(this.projectId, this.nodeId, this.fileName)
      // const s3Key = `${this.tenantStorage.getBaseDir()}${this.projectId}/${this.nodeId}/${this.fileName}`
      
      // ファイルサイズ
      // const size = file.size
      // const fileName = file.name
      // const fileBody = file.raw

      let contentType = mime.lookup(this.fileName)
      console.log(`contentType:${contentType}`)
      const option = {"ContentType": contentType}

      try {
        // S3バケットにファイルを保存
        console.log(`s3Key:${s3Key}`)
        await this.tenantStorage.put(s3Key, this.fileBody, option)
      } catch (e) {
        alert(`S3アップロード失敗 ${e.message}`)
        throw e
      }
      // 更新データにファイル名とキーをセット
      // this.mutateViewModel.backImage.backImage.name = path.basename(this.uploadFiles[0].name);
      // this.mutateViewModel.backImage.backImage.filePath = s3Key
      return s3Key
      // const ext = fileName.split(".")[1].toLowerCase()

      // console.log(`fileType:${this.fileType}`)

    } catch (e) {
      console.log(`${JSON.stringify(e)}`)
      return ""
    }
  }
  async save() {
    try {
      // ファイルアップロード
      const s3Key = await this.uploadFile()
      if (!s3Key) {
        throw new Error(`ファイルアップロード失敗`)
      }
      this.treeItem.treeItem.path = s3Key
      this.treeItem.treeItem.label = this.fileName
      this.treeItem.treeItem.fileSize = this.fileSize
      console.log(`save ${JSON.stringify(this.treeItem)}`)
      // ツリー項目を登録
      await TreeItemModel.add(this.treeItem)
      
    } catch (e) {
      console.log(`FileUploadViewModel save error:${JSON.stringify(e)}`)
      throw e
    }
  }

  async delete() {
    try {
      // レコードを削除する
      await TreeItemModel.delete(this.treeItem)
      // ファイルを削除する
      await this.tenantStorage.delete(this.treeItem.treeItem.path)
      
    } catch (e) {
      console.log(`FileUploadViewModel delete error:${JSON.stringify(e)}`)
      throw e
    }
  }
}
module.exports = FileUploadViewModel;